export const ERROR_CONFIG = {
  500: {
    theme: 'default',
    logoUrl: 'https://staticcdn.ald-automotive.es/cmd/lg/logo-ald-h40.png',
    imageUrl: 'https://staticcdn.ald-automotive.es/cmd/dg/errorImage.png',
    title: '¡OOPS!<br/>Lo sentimos.',
    message:
      'Por favor contacta con nosotros en el teléfono que aparece en la pegatina del código QR.',
    phoneNumber: process.env.PHONE_ON_ERROR
  }
};
